import { create } from 'zustand';

import { OfferDetails } from 'codegen';

import { IOfferStore } from './types';

export const offerStoreValues: Readonly<IOfferStore> = {
  imgId: '',
  order: 0,
  status: null,
  selectItems: [],
  initialValues: {
    retailersValue: {
      displayRetailers: undefined,
      isExclusiveForRetailer: false,
    },
    zoneValue: {
      displayPriorityZoneId: undefined,
    },
    enValues: {
      description: '',
      displayName: '',
      imageMetadataId: '',
      termsAndConditions: '',
      displayTermsAndConditions: '',
    },
    frValues: {
      description: '',
      displayName: '',
      imageMetadataId: '',
      termsAndConditions: '',
      displayTermsAndConditions: '',
    },
    genericValues: {
      name: '',
      regions: [],
      quantity: 0,
      effectiveTo: undefined,
      effectiveFrom: undefined,
      maxRedeemsPerCollector: undefined,
      receiptAcceptanceDaysThreshold: 14,
      rewardScope: OfferDetails.rewardScope.LINE_ITEM,
    },
    milesConfigurationValues: {
      miles: 1,
      offerCode: '',
    },
  },
  identities: [],
};

export const offerStore = create<IOfferStore>()(() => offerStoreValues);
